// extracted by mini-css-extract-plugin
export default {"actList":"actKC3ListTable_actList__tft+M"};